import { jsxs as o, jsx as t } from "react/jsx-runtime";
import "react";
import { ResultsTableBody as m } from "../ResultsTableBody/ResultsTableBody.js";
import { ResultsTableHeader as i } from "../ResultsTableHeader/ResultsTableHeader.js";
import { classes as p } from "../../utils/helpers.js";
import { s as e } from "../../ResultsTable.module-B7M9y7hd.mjs";
function x({
  columns: s = [],
  results: l = [],
  noResultsMsg: a = "No results were returned",
  compactLayout: r = !1
}) {
  return /* @__PURE__ */ o("div", { className: p([
    e["results-table"],
    e["fade-in__wrapper"],
    r ? e["results-table--compact"] : "",
    r ? "results-table--compact" : ""
  ]), children: [
    /* @__PURE__ */ t(i, { columns: s }),
    /* @__PURE__ */ t(m, { columns: s, results: l, noResultsMsg: a })
  ] });
}
export {
  x as ResultsTable,
  x as default
};
